<ng-container [ngSwitch]="this.srvChat.currentState">
    <ng-container *ngSwitchCase="ChatDialogState.CREATE" [ngTemplateOutlet]="CREATE_TICKET"></ng-container>
    <ng-container *ngSwitchCase="ChatDialogState.ACTIVE" [ngTemplateOutlet]="ACTIVE"></ng-container>
    <ng-container *ngSwitchCase="ChatDialogState.END_CHAT" [ngTemplateOutlet]="END_CHAT"></ng-container>
    <ng-container *ngSwitchCase="ChatDialogState.MINIMIZED" [ngTemplateOutlet]="MINIMIZED"></ng-container>
    <ng-container *ngSwitchCase="ChatDialogState.CLOSED_BY_EMPLOYEE" [ngTemplateOutlet]="CLOSED_BY_EMPLOYEE"></ng-container>
    <ng-container *ngSwitchCase="ChatDialogState.OUTSIDE_OF_HOUR" [ngTemplateOutlet]="OUTSIDE_OF_HOUR"></ng-container>
</ng-container>

<ng-template #ACTIVE>
    <ng-container *ngIf="this.srvChatContext.getChatTicket()?.status == ChatStatus.SENT" [ngTemplateOutlet]="IN_QUEUE"></ng-container>
    <ng-container *ngIf="this.srvChatContext.getChatTicket()?.status == ChatStatus.DELIVERED" [ngTemplateOutlet]="CHATTING"></ng-container>
</ng-template>

<ng-template #CREATE_TICKET>
    <div class="container p-4 bg-white field-box chat-container">
        <div class="chat-header-container" [ngStyle]="UIUtilityService.getBankButtonStyle()">
            <div class="chat-header">
                <div class="ms-3 font-chatbox-header">{{'CHAT.CREATE_TICKET' | translate}}</div>
                <button mat-icon-button class="btn" (click)="this.changeState(ChatDialogState.CLOSE)">
                    <mat-icon svgIcon="falTimesCircle" class="icon-position"></mat-icon>
                </button>
            </div>
        </div>
        <app-chat-create-ticket></app-chat-create-ticket>
    </div>
</ng-template>

<ng-template #IN_QUEUE>
    <div class="container p-4 bg-white field-box chat-container">
        <div class="chat-header-container" [ngStyle]="UIUtilityService.getBankButtonStyle()">
            <div class="chat-header">
                <div class="ms-3 font-chatbox-header">{{this.srvChat.getChatDialogTitle()}}</div>
                <button mat-icon-button class="btn" (click)="this.changeState(ChatDialogState.MINIMIZED)">
                    <mat-icon svgIcon="falMinus" class="icon-position"></mat-icon>
                </button>
                <button mat-icon-button class="btn" (click)="this.changeState(ChatDialogState.END_CHAT)">
                    <mat-icon svgIcon="falCloseComment" class="icon-position font-crimson"></mat-icon>
                </button>
            </div>
        </div>
        <app-chat-in-queue></app-chat-in-queue>
    </div>
</ng-template>

<ng-template #CHATTING>
    <div class="container p-4 bg-white field-box chat-container">

        <div class="chat-header-container" [ngStyle]="UIUtilityService.getBankButtonStyle()">
            <div class="chat-header">
                <div class="ms-3 font-chatbox-header">{{this.srvChat.getChatDialogTitle()}}</div>
                <button mat-icon-button class="btn" (click)="this.changeState(ChatDialogState.MINIMIZED)">
                    <mat-icon svgIcon="falMinus" class="icon-position"></mat-icon>
                </button>
                <button mat-icon-button class="btn" (click)="this.changeState(ChatDialogState.END_CHAT)">
                    <mat-icon svgIcon="falCloseComment" class="icon-position"></mat-icon>
                </button>
            </div>
        </div>
        <app-chat-chatting></app-chat-chatting>
    </div>
</ng-template>

<ng-template #END_CHAT>
    <div class="container p-4 bg-white field-box chat-container">
        <div class="chat-header-container" [ngStyle]="UIUtilityService.getBankButtonStyle()">
            <div class="chat-header justify-content-end">
                <button mat-icon-button class="btn" (click)="this.changeState(ChatDialogState.MINIMIZED)">
                    <mat-icon svgIcon="falMinus" class="icon-position"></mat-icon>
                </button>
            </div>
        </div>
        <app-chat-end-chat></app-chat-end-chat>
    </div>
</ng-template>

<ng-template #CLOSED_BY_EMPLOYEE>
    <div class="container p-4 bg-white field-box chat-container">
        <div class="chat-header-container" [ngStyle]="UIUtilityService.getBankButtonStyle()">
            <div class="chat-header justify-content-end">
                <div class="ms-3 font-chatbox-header">{{this.srvChat.getChatDialogTitle()}}</div>
                <button mat-icon-button class="btn" (click)="this.changeState(ChatDialogState.CLOSE)">
                    <mat-icon svgIcon="falTimesCircle" class="icon-position"></mat-icon>
                </button>
            </div>
        </div>
        <app-chat-closing></app-chat-closing>
    </div>
</ng-template>

<ng-template #MINIMIZED>
    <div class="chat-container" [ngStyle]="this.getMinimizedWidth()">
        <div [ngStyle]="UIUtilityService.getBankButtonStyle()">
            <div class="chat-header">
                <div class="chat-header-title">
                    <p class="ms-3 my-0 font-chatbox-header">
                        {{this.srvChat.getChatDialogTitle()}}
                    </p>
                    <span *ngIf="this.srvChat.hasNewActivity | async"><mat-icon svgIcon="fasBell" class="activity"></mat-icon></span>
                </div>
                <button mat-icon-button class="btn" (click)="this.changeState(ChatDialogState.ACTIVE)">
                    <mat-icon svgIcon="falExternalLinkSquare" class="icon-position"></mat-icon>
                </button>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #OUTSIDE_OF_HOUR>
    <div class="container p-4 bg-white field-box chat-container">
        <div class="chat-header-container" [ngStyle]="UIUtilityService.getBankButtonStyle()">
            <div class="chat-header justify-content-end">
                <button mat-icon-button class="btn" (click)="this.changeState(ChatDialogState.CLOSE)">
                    <mat-icon svgIcon="falTimesCircle" class="icon-position"></mat-icon>
                </button>
            </div>
        </div>
        <app-chat-outside-of-hours></app-chat-outside-of-hours>
    </div>
</ng-template>